import { jsx } from 'react/jsx-runtime';
import { css } from '@emotion/css';
import { Switch } from '@grafana/ui';
import 'react';

const EditorSwitch = (props) => {
  const styles = getStyles();
  return /* @__PURE__ */ jsx("div", { className: styles.switch, children: /* @__PURE__ */ jsx(Switch, { ...props }) });
};
const getStyles = () => {
  return {
    switch: css({
      display: "flex",
      alignItems: "center",
      minHeight: 30
    })
  };
};

export { EditorSwitch };
//# sourceMappingURL=EditorSwitch.js.map
